import React, { useCallback, useEffect, useRef, useState } from 'react';
import Input from '../input/input';
import { classnames } from '../../../utils/classnames';
import Validators from '../../../utils/validation';

export default function Select({
  className,
  options,
  name,
  onChange,
  label,
  value,
  onFocus,
  disabled = false,
  isRequired = true,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleChange = (event, name, value) => {
    event.stopPropagation();
    onChange(name, value);
    handleClose();
  };

  const checkHide = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      handleClose();
    }
  };

  useEffect(() => {
    document.body.addEventListener('click', checkHide);

    return () => {
      document.body.removeEventListener('click', checkHide);
    };
  }, []);

  const handleClick = (event) => {
    if (disabled) return;
    event.stopPropagation();
    onFocus && onFocus();
    setOpen((prev) => !prev);
  };

  return (
    <div
      ref={ref}
      className={classnames(
        className,
        'select',
        'select-small',
        'form__select',
        open && 'js-active',
        disabled && 'select_disabled',
      )}
      role="presentation"
    >
      <div onClick={handleClick}>
        <Input
          name={name}
          value={value || ''}
          onChange={onChange}
          label={label}
          disabled={disabled}
          withoutHint
          readonly
          rules={!disabled && isRequired ? [Validators.required] : []}
        />
      </div>
      <div className={classnames('select-menu')}>
        <Options options={options} value={value} handleChange={handleChange} name={name} />
      </div>
    </div>
  );
}

const Options = ({ options, value, handleChange, name }) => {
  return (
    <div className="select-menu__container">
      {options.length > 0 ? (
        options.map((option) => (
          <div
            role="presentation"
            key={option}
            className={`select-menu__item ${value === option && 'select-menu__item_active'}`}
            onClick={(event) => handleChange(event, name, option)}
          >
            {option}
          </div>
        ))
      ) : (
        <div className="select-menu__item select-menu__item-disabled">Nothing found</div>
      )}
    </div>
  );
};
